import React from "react";
import Form from "react-bootstrap/Form";

const CustomFormTextArea = ({
  controlText,
  color,
  lableText,
  placeholderText,
  rows,
  value,
  onChange,
}) => {
  return (
    <Form.Group controlId={controlText}>
      <Form.Label style={{ color: color }}>{lableText}</Form.Label>
      <Form.Control
        onChange={onChange}
        value={value}
        as={"textarea"}
        rows={rows}
        placeholder={placeholderText}
      />
    </Form.Group>
  );
};
export default CustomFormTextArea;
